import { PlansDataRouteType } from "routes/data-routes/billing-data/plans/route.meta";
import scraperApi from "api";


export const loader: PlansDataRouteType["route"]["loader"] = async ({ request }) => {
  return {
    allPlans: await scraperApi.billing.getPlans({ signal: request.signal })
  };
};
